import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {MuralImage} from "./mural-image";

const MuralImagePage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/users');
    }

    return (
        <MuralImage id={id} onClose={onClose}/>
    )

});

export default MuralImagePage;